<div [ngStyle]="{ height: '100%' }" fxLayout="column">
  <div fxFlex="100%" class="u-overflow-auto u-showScrollBar u-padding-24">
    <form [formGroup]="form">
      <mat-form-field class="mat-form-field-width-100 u-marginBottom-24">
        <mat-label i18n="@@hubConfigRolesDrawer.formLabel.roleName"
          >Role name</mat-label
        >
        <input
          matInput
          formControlName="name"
          autocomplete="off"
          placeholder="Input role name"
          [maxlength]="roleNameLimit"
          required
        />
        <mat-hint align="end">
          {{ form.get('name').value.length }}/{{ roleNameLimit }}
        </mat-hint>
      </mat-form-field>
      <p class="color-grey text-subtitle-2">
        <ng-container *ngIf="data.role?.name; else newRole">
          <b i18n="@@hubConfigRolesDrawer.newRoleInteractionsTitle.default"
            >Default interactions</b
          >
        </ng-container>
        <ng-template #newRole>
          <b i18n="@@hubConfigRolesDrawer.newRoleInteractionsTitle.enabled"
            >Enabled interactions</b
          ></ng-template
        >
      </p>
      <p
        class="color-grey-300 u-marginBottom-16"
        i18n="@@hubConfigRolesDrawer.interactionsDescription"
      >
        Customize how members can interact in this community. Members can also
        change these settings in their hub profile.
      </p>
      <div
        *ngIf="data.showOptedIntoMatchmaking"
        class="u-marginBottom-8"
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="16px"
      >
        <p
          fxFlex="100%"
          i18n="@@hubConfigRolesDrawer.formLabel.optedIntoMatchmaking"
        >
          Receive automated Introductions to other members
        </p>
        <mat-slide-toggle
          formControlName="opted_into_matchmaking"
        ></mat-slide-toggle>
      </div>
      <div
        *ngIf="
          data.showInviteable &&
          (tenantState | async)?.enabled_features?.conversations
        "
        class="u-marginBottom-8"
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="16px"
      >
        <p fxFlex="100%" i18n="@@hubConfigRolesDrawer.formLabel.inviteable">
          Receive messages from other members
        </p>
        <mat-slide-toggle formControlName="inviteable"></mat-slide-toggle>
      </div>
      <div
        *ngIf="data.showSearchable"
        class="u-marginBottom-8"
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="16px"
      >
        <p fxFlex="100%" i18n="@@hubConfigRolesDrawer.formLabel.searchable">
          Other members can search for members in this role
        </p>
        <mat-slide-toggle formControlName="searchable"></mat-slide-toggle>
      </div>
    </form>
    <div
      fxLayout="row"
      fxLayoutAlign="start start"
      fxLayoutGap="4px"
      class="color-grey-300 u-marginTop-16 text-caption"
    >
      <mat-icon class="md-16">info_outline</mat-icon>
      <p i18n="@@hubConfigRolesDrawer.tip">
        Members can change these settings in their hub profile.
      </p>
    </div>
  </div>
  <div
    class="u-padding-8-0 u-padding-0-16 u-borderTop-grey100"
    fxFlex="0 0 auto"
    fxLayoutAlign="end center"
    fxLayoutGap="8px"
  >
    <button
      mat-button
      color="primary"
      [disabled]="isLoading"
      (click)="closeDrawer()"
      i18n="@@global.cancel"
    >
      Cancel
    </button>
    <button
      color="primary"
      mat-raised-button
      (click)="submitForm()"
      [disabled]="isLoading || !form.valid"
    >
      <span i18n="@@global.save">Save</span>
      <i
        *ngIf="isLoading"
        nz-icon
        nzType="sync"
        class="u-marginLeft-8"
        nzSpin
      ></i>
    </button>
  </div>
</div>
